import { ModalProps } from 'antd';

import Image from 'global/Image';

import {
  Modal,
  CloseIcon,
  Container,
  ImageWrapper,
  ContentWrapper,
  Title,
  Description,
  ButtonWrapper,
  Button,
} from './link-error.styled';

interface LinkErrorProps extends ModalProps {
  onSubmit: () => void;
  onCancel: () => void;
  title: string;
}

export default function LinkError({
  visible,
  onSubmit,
  onCancel,
  title,
}: Readonly<LinkErrorProps>) {
  const errorImage = '/illustration/stream-error-link.svg';

  const handleSubmit = () => {
    onSubmit();
  };

  return (
    <Modal
      centered
      title={null}
      closeIcon={<CloseIcon />}
      footer={null}
      visible={visible}
      onOk={handleSubmit}
      onCancel={onCancel}
      zIndex={1050}
    >
      <Container>
        <ImageWrapper>
          <Image src={errorImage} alt="" />
        </ImageWrapper>

        <ContentWrapper>
          <Title style={{ marginTop: 16 }}>{title}</Title>
          <Description style={{ width: 310 }}>
            Buka akun Stockbit Sekuritas terlebih dahulu untuk verifikasi data
            identitas kamu.
          </Description>
          <Description style={{ marginTop: 16 }}>
            Pembatasan ini bertujuan untuk melindungi kenyamanan dan keamanan
            komunitas Stockbit.
          </Description>
        </ContentWrapper>

        <ButtonWrapper>
          <Button type="primary" onClick={handleSubmit}>
            Buka Akun Stockbit Sekuritas
          </Button>
        </ButtonWrapper>
      </Container>
    </Modal>
  );
}
